import React, { useEffect, useRef, useState } from 'react';

import { useNavigate, useLocation, Link } from 'react-router-dom';
import moment from 'moment';
import { motion, useMotionValueEvent, useScroll } from "framer-motion";

import Image from './Image';

import images from '../libs/images';
import consts from '../libs/consts';
import routes from '../libs/routes';

import { useUser, useMenu, usePopup, useHeader } from "../zustand/store.js";
import { numFormat, useWindowSize } from '../utils/utils';

import { LangText } from "../zustand/dict.js";
import LeftNavCredit from './LeftNavCredit.js';
import LeftNavLang from './LeftNavLang.js';

const hideRoute = [routes.login];
const variants = {
    open: { opacity: 1, display: 'flex' },
    closed: { opacity: 0, display: 'none' },
}
const variantsUl = {
    open: {
        transition: { staggerChildren: 0.07, delayChildren: 0 }
    },
    closed: {
        transition: { staggerChildren: 0.05, delayChildren: 0.3, staggerDirection: -1 }
    }
};
const variantsItem = {
    open: {
        y: 0,
        opacity: 1,
        transition: {
            y: { stiffness: 1000, velocity: -100 }
        }
    },
    closed: {
        y: 20,
        opacity: 0,
        transition: {
            y: { stiffness: 1000 }
        }
    }
}

export default function LeftNav() {

    const navigate = useNavigate();
    const location = useLocation();

    const { width, height } = useWindowSize();
    const [show, setShow] = useState(true);

    const { menu } = useMenu();
    const { menuPop, openMenu, closeMenu } = usePopup();
    const { setHeaderMode } = useHeader();
    const { user, token } = useUser();

    const menuContainRef = useRef(null);
    const [creditOpen, setCreditOpen] = useState(false);
    const [langOpen, setLangOpen] = useState(false);

    useEffect(() => {

        if (width <= consts.mobileWidth) {
            closeFunc();
        }

    }, [location.pathname]);

    useEffect(() => {

        if (width <= consts.mobileWidth) {
            closeFunc();
        } else {
            setCreditOpen(false)
            setLangOpen(false)
            openMenu();
        }

    }, [width]);

    useEffect(() => {
        if (menuPop) {
            setHeaderMode({
                mode: consts.headerMode.BACK,
                onBackClick: () => {
                    closeFunc();
                }
            })
        } else {
            setHeaderMode({
                mode: consts.headerMode.NORMAL,
            })
        }
    }, [menuPop])

    useEffect(() => {
        if (creditOpen || langOpen) {
            menuContainRef.current.scrollTop = 0
            menuContainRef.current.style.overflowY = "hidden"
        } else {
            menuContainRef.current.style.overflowY = ""
        }
    }, [creditOpen, langOpen])

    const closeFunc = () => {
        setCreditOpen(false)
        setLangOpen(false)
        closeMenu();
    }

    const setHeader = (type = 1) => {
        const creditBack = () => {
            setCreditOpen(false);
            setHeaderMode({
                mode: consts.headerMode.BACK,
                onBackClick: () => {
                    closeFunc();
                }
            })
        }
        const langBack = () => {
            setLangOpen(false);
            setHeaderMode({
                mode: consts.headerMode.BACK,
                onBackClick: () => {
                    closeFunc();
                }
            })
        }

        setHeaderMode({
            mode: consts.headerMode.BACK,
            onBackClick: type == 1 ? langBack : creditBack
        })
    }

    const linkFunc = (link) => {
        // dispatch(reset());
        if (link) {
            // dispatch( setPopupStorage({ key: 'cadastral', value: false }) );
            // dispatch( setPopupStorage({ key: 'drawing', value: false }) );
            navigate(link);
        }
    }


    return (
        <>
            <motion.div
                className={`left_nav_dim`}
                initial={consts.loaderVariants.closed}
                animate={(menuPop && width <= consts.mobileWidth) ? "open" : "closed"}
                variants={consts.loaderVariants}
                onClick={e => {
                    if (e.target !== e.currentTarget) return;
                    closeMenu();
                }}
            />

            <motion.div
                ref={menuContainRef}
                style={{ overflowX: "hidden" }}
                className={`left_nav`}
                initial={variants.closed}
                animate={menuPop ? "open" : "closed"}
                variants={variants}
            >

                <div className='left_nav_container'>
                    <div className='left_nav_group'>
                        <p className='title'>For Images</p>
                        <motion.ul variants={variantsUl}>
                            {menu?.filter(x => x?.type === 'image')?.map((x, i) => {
                                return (
                                    <motion.li
                                        style={{ position: 'relative' }}
                                        key={`i_` + i}
                                        initial={variantsItem.closed}
                                        variants={variantsItem}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        <Link
                                            className={`left_nav_one`}
                                            to={routes['menu_' + x?.index]}
                                        >
                                            <Image className={['img']} src={consts.imgUrl + x?.icon} />
                                            <p className='title'>
                                                <LangText id={x?.name_key} />
                                            </p>

                                        </Link>
                                        {location.pathname === routes['menu_' + x?.index] ? (
                                            // <motion.div className="left_nav_bg" initial={{zIndex: -1}} layoutId="left_nav_bg" />
                                            <div className="left_nav_bg" initial={{ zIndex: -1 }} layoutId="left_nav_bg" />
                                        ) : null}
                                    </motion.li>
                                )
                            })}
                        </motion.ul>
                    </div>

                    <div className='left_nav_group'>
                        <p className='title'>For Video</p>
                        <motion.ul variants={variantsUl}>
                            {menu?.filter(x => x?.type === 'video')?.map((x, i) => {
                                return (
                                    <motion.li
                                        style={{ position: 'relative' }}
                                        key={`v_` + i}
                                        initial={variantsItem.closed}
                                        variants={variantsItem}
                                        whileTap={{ scale: 0.95 }}
                                    >
                                        <Link
                                            className={`left_nav_one`}
                                            to={routes['menu_' + x?.index]}
                                        >
                                            <Image className={['img']} src={consts.imgUrl + x?.icon} />
                                            <p className='title'>
                                                <LangText id={x?.name_key} />
                                            </p>
                                        </Link>
                                        {location.pathname === routes['menu_' + x?.index] ? (
                                            // <motion.div className="left_nav_bg" layoutId="left_nav_bg" />
                                            <div className="left_nav_bg" layoutId="left_nav_bg" />
                                        ) : null}
                                    </motion.li>
                                )
                            })}
                        </motion.ul>
                    </div>
                </div>

                <motion.ul
                    className='left_nav_header margint50'
                    variants={variantsUl}>
                    <motion.li
                        style={{ position: 'relative' }}
                        initial={variantsItem.closed}
                        variants={variantsItem}
                        whileTap={{ scale: 0.98 }}
                    >
                        <Link
                            className={`left_nav_one`}
                            onClick={() => {
                                setLangOpen(true)
                                setHeader(1)
                            }}
                        >
                            <Image className={['img']} src={images.icn_language} />
                            <p className='title'>
                                {/* <LangText id={""} /> */}
                                <LangText id={'text_set_language'} />
                            </p>
                        </Link>

                    </motion.li>
                    {token && <motion.li
                        style={{ position: 'relative' }}
                        initial={variantsItem.closed}
                        variants={variantsItem}
                        whileTap={{ scale: 0.98 }}
                    >
                        <Link
                            className={`left_nav_one`}
                            onClick={() => {
                                setCreditOpen(true);
                                setHeader(2)
                            }}
                        >
                            <Image className={['img']} src={images.icn_credit} />
                            <p className='title'>
                                <LangText id={'text_credit'} />
                            </p>
                        </Link>
                    </motion.li>}

                </motion.ul>

                <div className="left_nav_footer">
                    <div className='sns_box'>
                        <Image src={images.insta} onClick={() => window.open('https://www.instagram.com/')} />
                        {/* <Image src={images.insta} onClick={() => window.open('https://www.instagram.com/')}/> */}
                    </div>
                    <p className='title'>{`LAB.AIWITH.ART © 2024\nAll rights reserved.`}</p>
                </div>

                <LeftNavLang isOpen={langOpen} />
                <LeftNavCredit isOpen={creditOpen} />

            </motion.div>

        </>
    )
}